import React, { Fragment } from 'react';
import Router from './Router';
import { BrowserRouter } from 'react-router-dom';
import { Header } from './common/Header';
import { Footer } from './common/Footer';
import ScrollToTop from './ScrollToTop';
import "./App.css"

function App() {
  return (
    <Fragment>
      <BrowserRouter>
      <ScrollToTop />
          <Router />
      </BrowserRouter>
    </Fragment>
  );
}

export default App;
